/**
 * 로그인 뒤 돌아갈 경로(`redirect` 파라미터)를 검증한다. **앱 내부 경로만** 허용한다.
 * `//evil.com`, `/\evil.com`, 절대 URL, `javascript:` 등은 기본 경로로 바꾼다.
 */
export const REDIRECT_PARAM = 'redirect';

const INTERNAL_BASE = 'http://internal.invalid';
// eslint-disable-next-line no-control-regex -- 제어 문자를 막는 것이 목적이다
const CONTROL_CHARS = /[\u0000-\u001f\u007f]/;

export function toSafeRedirectPath(raw: string | null | undefined, fallback = '/'): string {
  if (!raw) return fallback;
  if (!raw.startsWith('/')) return fallback;
  if (raw.startsWith('//') || raw.startsWith('/\\')) return fallback;
  if (raw.includes('\\') || CONTROL_CHARS.test(raw)) return fallback;

  try {
    const url = new URL(raw, INTERNAL_BASE);
    if (url.origin !== INTERNAL_BASE) return fallback;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}

/** 현재 위치를 `redirect` 로 실어 로그인 경로를 만든다. */
export function buildLoginPath(loginPath: string, current: string): string {
  const safe = toSafeRedirectPath(current, '');
  if (!safe || safe === '/' || safe.startsWith(loginPath)) return loginPath;
  return `${loginPath}?${REDIRECT_PARAM}=${encodeURIComponent(safe)}`;
}
